import { render, staticRenderFns } from "./SpecialTV.vue?vue&type=template&id=640f86c3&"
import script from "./SpecialTV.vue?vue&type=script&lang=js&"
export * from "./SpecialTV.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTV.vue?vue&type=style&index=0&id=640f86c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports